import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  Box,
  Center,
  Image,
  Text,
} from "@chakra-ui/react";

export default function ModalConfirmation({ message, messageDialogRef }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <Center>
      <Button d="none" ref={messageDialogRef} onClick={onOpen}></Button>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Post Status</ModalHeader>
          <ModalBody>
            <Text>{message}</Text>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Center>
  );
}
